import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { appConstants } from '../common-service/const.model';
import { ToastrService } from 'ngx-toastr';
import { encryptionService } from '../../app/common-service/cedService';
import { SignupService } from '../common-service/signup.service';
import { UsrmgtService } from '../usermgt/services/usrmgt.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServerURLService } from '../common-service/serverURL.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CollegeProfileService } from '../college/collegeprofile/services/collegeProfile.service';
declare var grecaptcha: any;

@Component({
  selector: 'app-forgot-user',
  templateUrl: './forgot-user.component.html',
  styleUrls: ['./forgot-user.component.css']
})
export class ForgotUserComponent implements OnInit {
  forgotusrForm: FormGroup;
  captchImage: any;
  errorMsgs: any;
  submitted = false;
  invalidLogin: boolean = false;
  captchaError: boolean = false;
  loginResponse: string;
  siteKey: string='6LeiApIfAAAAAOBsKqX0U-EQNu3lk3O9LVByiRAA';
  randomSecretKey: any;
  captchaImage: any;
  isSubmitted: boolean;
  maxAgeDate: any;

  studentDetails = {
    studentName: '',
    fatherName: '',
    mobileNumber: '',
    dateOfBirth: '',
    captcha: '',
    captchaPath: ''
  }
  module: any;
  moduleStdReg: boolean = false;
  
  constructor(public fb: FormBuilder, public constValues: appConstants, public toastr: ToastrService,
    public ced: encryptionService, public usrmgtService: UsrmgtService, public router: Router, 
    public serverURL: ServerURLService, public signin: SignupService, public spinner: NgxSpinnerService, 
    public collegeProfileService: CollegeProfileService, public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getCaptchaValue();
    this.maxAgeDate = this.collegeProfileService.ageMaxDate();

    this.errorMsgs = this.constValues.errorMsgs;
    this.forgotusrForm = this.fb.group({
      studentName: ['', Validators.required],
      fatherName: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      captcha: ['', Validators.required]
    });

    if (this.route.snapshot.paramMap.get("module") != null
    && this.route.snapshot.paramMap.get("module") != "NaN") {
      this.route.params.subscribe(params => {
        this.module = params.module;
      });
      if(this.module == 'student') {
        this.moduleStdReg = true;
      } else {
        this.moduleStdReg = false;
      }   
    } else {
      this.moduleStdReg = false;
    } 

    this.clearSession();
    this.errorMsgs = this.constValues.errorMsgs;
  }
  get f() { return this.forgotusrForm.controls; } // Controls

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  toCallRecaptha(){
    grecaptcha.reset();
  }

  // getRandomKeyGenerator
  getRandomKeyGenerator() {
    this.submitted = true;
    if (this.forgotusrForm.valid) {
      if (this.forgotusrForm.value.captcha === this.captchaImage) {
    this.randomSecretKey='';
    this.spinner.show();
    this.signin.getRandomKeyGenerator().subscribe((data: any) => {
     this.randomSecretKey=this.ced.decryptAesformString(data.randamKey, this.serverURL.secretKey);
     this.submitCaptcha();
   }, error => {
     this.getCaptchaValue();
     this.clearSession();
     this.toastr.error('Enter Valid Details', 'Error', {
         timeOut: 3000
       });
     });
       } else {        
      this.spinner.hide();
      this.clearSession();
      this.toastr.error('Enter Valid Captcha', 'Error', {
        timeOut: 3000
      });
    }
     } else {
      this.spinner.hide();     
      // this.generateCaptcha();
      grecaptcha.reset();
      this.clearSession();
     }
    }

   generateCaptcha() {
    const alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
      'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd',
      'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
      't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0');
    let i;
    for (i = 0; i < 4; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = alpha[Math.floor(Math.random() * alpha.length)];
    }
    const code = a + '' + b + '' + '' + c + '' + d + '' + e;
    this.captchImage = code;
  }

  
  submitCaptcha() {
    this.submitted = true;
    if (this.forgotusrForm.valid) {      
        if (this.forgotusrForm.value.captcha === this.captchaImage) {
      const resetObj = {
        studentName: this.studentDetails.studentName,
        fatherName: this.studentDetails.fatherName,
        dateOfBirth: this.studentDetails.dateOfBirth,
        mobileNumber: this.ced.encryptAesToString(this.studentDetails.mobileNumber, this.randomSecretKey).toString(),
        captcha: this.forgotusrForm.value.captcha,
        captchaPath: this.ced.encryptAesToString(this.captchaImage, this.randomSecretKey).toString()
      };
        this.usrmgtService.forgotUser(resetObj).subscribe((res: any) => {     
          this.spinner.hide();     
          if(res.response.respcode === "200") {
            this.toastr.success('User ID sent to your registered Mobile no.', 'Success', {
              timeOut: 3000
            });
            this.router.navigate(['/login/student']);
          } else if(res.response.respcode === "500") {
            this.toastr.error(res.response.message, 'Error', {
              timeOut: 3000
            });
          } else if(res.response.respcode === "100") {
            this.toastr.error('Invalid Captcha', 'Error', {
              timeOut: 3000
            });
          } else {
            this.getCaptchaValue();
            this.clearSession();
            this.toastr.error('Enter Valid Details', 'Error', {
              timeOut: 3000
            });
          }      
          this.getCaptchaValue();
          this.clearSession();
        }, error => {
          this.spinner.hide();     
          this.getCaptchaValue();
          this.clearSession();

          if (error.error == "Invalid captcha") {
            this.toastr.error('Invalid captcha', 'Error', {
              timeOut: 3000
            });
          } else {
            this.toastr.error('Enter Valid Details', 'Error', {
              timeOut: 3000
            });
          }
          this.clearSession();
        });      
    } else {
      this.spinner.hide();   
      this.clearSession(); 
      this.toastr.error('Enter Valid Captcha', 'Error', {
        timeOut: 3000
      });
    } } else {
      this.spinner.hide();     
      this.getCaptchaValue();
      this.clearSession();
    }
  }

  getCaptchaValue() {
    this.usrmgtService.getCaptchaValue().subscribe((result: any) => {
      this.captchaImage = this.ced.decryptAesformString(result.captcha, this.serverURL.secretKey);
    });
  }

     // Check Validation For Only Numeric Value
     keyPress(event: any) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode !== 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
}

